import { jsx as _jsx } from "react/jsx-runtime";
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
import RewardBanner from '../../../../../ui/atoms/RewardBanner';
import useRewards from '../../../../../hooks/useRewards';
var ModalBanner = function () {
    var _a, _b, _c, _d;
    var isLessThanMobile = useWindowSize().isLessThanMobile;
    var _e = useRewards(), cardType = _e.cardType, clientId = _e.clientId, rewardsExperience = _e.rewardsExperience;
    var defaultBanner = (_b = (_a = rewardsExperience === null || rewardsExperience === void 0 ? void 0 : rewardsExperience[clientId]) === null || _a === void 0 ? void 0 : _a[cardType]) === null || _b === void 0 ? void 0 : _b.banner;
    var mobileBanner = (_d = (_c = rewardsExperience === null || rewardsExperience === void 0 ? void 0 : rewardsExperience[clientId]) === null || _c === void 0 ? void 0 : _c[cardType]) === null || _d === void 0 ? void 0 : _d.bannerSm;
    var bannerImg = isLessThanMobile && mobileBanner ? mobileBanner : defaultBanner;
    return bannerImg ? _jsx(RewardBanner, { client: clientId, image: bannerImg }) : null;
};
export default ModalBanner;
